<template>
    <div class="noticeItemWrap">
        <p class="title">{{NoticeItem.title}}</p>
        <div class="date">{{NoticeItem.description}}</div>
    </div>
</template>
<script>
export default {
    name:'coItem',
    props: ['NoticeItem']
}
</script>
<style lang="scss" scoped>
    .noticeItemWrap{
        width: 100%;
        padding: 0.5rem 0 0.35rem;
        border-bottom: 1px solid rgba($color: #7A7A7A, $alpha: 0.3);
        box-sizing: border-box;
        .title{
            font-size: 0.26rem;
            font-weight: 400;
            color: #000000;
            line-height: 0.4rem;
            display:-webkit-box;/**对象作为伸缩盒子模型展示**/
            -webkit-box-orient:vertical;/**设置或检索伸缩盒子对象的子元素的排列方式**/
            -webkit-line-clamp:3;/**显示的行数**/
            overflow:hidden;/**隐藏超出的内容**/
        }
        .date{
            font-size: 0.24rem;
            font-weight: 400;
            color: #AAAAAA;
            margin-top: 0.2rem;
            line-height: 0.4rem;
        }
    }
</style>


// WEBPACK FOOTER //
// src/components/coItem.vue